module.exports = ".grid-row {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 30px 100px 20% auto 60px 75px 10px 30px;\n      grid-template-columns: 30px 100px 20% auto 60px 75px 10px 30px;\n  grid-column-gap: 15px; }\n  .grid-row > * {\n    word-break: break-all; }\n  .grid-row-edit {\n    -ms-grid-columns: 30px auto 32px;\n        grid-template-columns: 30px auto 32px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/configuration-views/configuration-views.component.scss
// module id = ./src/app/pages/configuration-views/configuration-views.component.scss
// module chunks = main